import useMutationCall from "../../../hooks/useMutationCall";
import { useAddRoleToEmployeeMutation } from "../employeesSlice";

const useAddRoleToEmployee = () => {
  return useMutationCall(useAddRoleToEmployeeMutation);
};

export default useAddRoleToEmployee;
